import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_MEDIA_CLASS,
  ITEM_MEDIA_DEFAULTS,
  ITEM_MEDIA_VARIANT_CLASS_MAP,
  TItemMediaProps,
} from "@/ui/components/data-display/Item/Item.config";

export const ItemMedia: FC<TItemMediaProps> = (
  {
    className,
    variant = ITEM_MEDIA_DEFAULTS.variant,
    children,
    ...props
  },
) => (
  <div
    {...props}
    data-variant={variant}
    data-component="ItemMedia"
    className={cn(
      ITEM_MEDIA_CLASS,
      ITEM_MEDIA_VARIANT_CLASS_MAP[variant],
      className,
    )}
  >
    { children }
  </div>
);

ItemMedia.displayName = "ItemMedia";
